module.exports = __webpack_public_path__ + "static/c6-5e866c49719cee555c9b911cabe420b5.jpeg";